import React from 'react'
import cx from 'classnames'
import styles from './InfoGatheringDialog.sass'

interface InfoGatheringDialogScrollAreaProps {
  children: React.ReactNode
}

export function InfoGatheringDialogScrollArea({
  children,
}: InfoGatheringDialogScrollAreaProps) {
  return (
    <div className={styles.scrollArea}>
      <div className={styles.scrollAreaInner}>{children}</div>
    </div>
  )
}

interface InfoGatheringDialogSubsectionHeaderProps {
  bordered?: boolean
  children: React.ReactNode
}

export function InfoGatheringDialogSubsectionHeader({
  bordered,
  children,
}: InfoGatheringDialogSubsectionHeaderProps) {
  return (
    <div
      className={cx(
        styles.subsectionHeader,
        bordered && styles.subsectionHeaderBordered,
      )}
    >
      {children}
    </div>
  )
}

interface InfoGatheringDialogFieldGridProps {
  children: React.ReactNode
}

export function InfoGatheringDialogFieldGrid({
  children,
}: InfoGatheringDialogFieldGridProps) {
  return <div className={styles.fieldGrid}>{children}</div>
}
